;(function () {
  angular
    .module('contrast.application.vulnerabilities')
    .controller('AppVulnUnauthorizedCtrl', AppVulnUnauthorizedCtrl)

  function AppVulnUnauthorizedCtrl(
    _,
    $scope,
    $routeParams,
    traceRenderers,
    ErrorService,
    appTracesApiConfig
  ) {
    'ngInject'

    var appId = $routeParams.appId
    var traceUuid = $routeParams.uuid

    angular.extend($scope, {
      isSticky: false,
      model: {
        trace: undefined,
        type: 'app'
      },
      loadTracePromise: false
    })

    function init() {
      $scope.loadTracePromise = false

      appTracesApiConfig
        .getVulnerabilityShort(appId, traceUuid, traceUuid)
        .then(
          function (response) {
            $scope.loadTracePromise = true

            $scope.model.trace = response.data.trace
            var escapedTitle = _.escape($scope.model.trace.title)
            $scope.model.trace.title = escapedTitle
              ? mustache.render(escapedTitle, traceRenderers)
              : ''
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
    }

    init()
  }
})()
